import { reactive, readonly } from 'vue'

// Create a reactive loading state store
const loadingState = reactive({
  isLoading: false,
  loadingMessage: '',
  loadingTasks: new Set(),
  globalLoading: false
})

export const useLoadingStore = () => {
  const startLoading = (taskId, message = 'Loading...') => {
    loadingState.loadingTasks.add(taskId)
    loadingState.isLoading = true
    loadingState.loadingMessage = message
    loadingState.globalLoading = true
  }

  const stopLoading = (taskId) => {
    loadingState.loadingTasks.delete(taskId)
    
    if (loadingState.loadingTasks.size === 0) {
      loadingState.isLoading = false
      loadingState.loadingMessage = ''
      loadingState.globalLoading = false
    }
  }

  const setGlobalLoading = (isLoading, message = 'Loading...') => {
    loadingState.globalLoading = isLoading
    loadingState.loadingMessage = message
    if (isLoading) {
      loadingState.isLoading = true
    }
  }

  const clearAllLoading = () => {
    loadingState.loadingTasks.clear()
    loadingState.isLoading = false
    loadingState.loadingMessage = ''
    loadingState.globalLoading = false
  }

  return {
    loadingState: readonly(loadingState),
    startLoading,
    stopLoading,
    setGlobalLoading,
    clearAllLoading
  }
}

export const loadingStore = {
  state: readonly(loadingState),
  startLoading: (taskId, message) => {
    loadingState.loadingTasks.add(taskId)
    loadingState.isLoading = true
    loadingState.loadingMessage = message
    loadingState.globalLoading = true
  },
  stopLoading: (taskId) => {
    loadingState.loadingTasks.delete(taskId)
    
    if (loadingState.loadingTasks.size === 0) {
      loadingState.isLoading = false
      loadingState.loadingMessage = ''
      loadingState.globalLoading = false
    }
  },
  setGlobalLoading: (isLoading, message) => {
    loadingState.globalLoading = isLoading
    loadingState.loadingMessage = message
    if (isLoading) {
      loadingState.isLoading = true
    }
  },
  clearAllLoading: () => {
    loadingState.loadingTasks.clear()
    loadingState.isLoading = false
    loadingState.loadingMessage = ''
    loadingState.globalLoading = false
  }
}
